import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DataTable from "react-data-table-component";
import { societiesColumns } from "./utils/columns";
import DeleteConfirmationModal from "./DeleteConfirmationModal";
import { Button, Col, Input, Label, Row } from "reactstrap";
import { ChevronDown, PlusSquare } from "react-feather";
import CustomPagination from "./customPagination";
import { createCompanyPositions, deleteCompanyPositions, updateCompanyPositions } from "../thunks";
import CompanyPositionsFormModal from "./CompanyPositionsFormModal";

const CompanyPositionsTable = () => {
  const dispatch = useDispatch();
  const { list, loading } = useSelector((state) => state.companyPositions);
  const [searchTerm, setSearchTerm] = useState("");
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isFormModalOpen, setIsFormModalOpen] = useState(false);
  const [selectedSociety, setSelectedSociety] = useState(null);
  const [currentPage, setCurrentPage] = useState(0)


  useEffect(() => {
    //dispatch(fetchSocieties());
  }, [dispatch]);

  const toggleDeleteModal = () => setIsDeleteModalOpen(!isDeleteModalOpen);
  const toggleCreateModal = () => setIsCreateModalOpen(!isCreateModalOpen);

  const toggleFormModal = () => {
    setSelectedSociety(null);
    setIsFormModalOpen(!isFormModalOpen);
  };

  const handleDelete = (id) => {
    setSelectedSociety(list.find((society) => society.id === id));
    toggleDeleteModal();
  };

  const confirmDelete = () => {
    if (selectedSociety) {
      dispatch(deleteCompanyPositions(selectedSociety.id));
    }
    toggleDeleteModal();
  };

  const handleSubmitSociety = (data) => {
    if (selectedSociety) {
      console.log("Sociedad seleccionada: ", selectedSociety)
      // Si hay una sociedad seleccionada, se actualiza
      dispatch(updateCompanyPositions({ id: selectedSociety.id, ...data }));
    } else {
      // De lo contrario, se crea una nueva
      console.log("Sociedad: ", data)
      dispatch(createCompanyPositions(data));
    }
    toggleFormModal();
  };

  const handleEdit = (society) => {
    setSelectedSociety(society); // Carga la sociedad seleccionada en el formulario
    setIsFormModalOpen(true);
  };

  const filteredSocieties = list?.filter((society) =>
    society.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handlePagination = (page) => {
    setCurrentPage(page.selected);
  };

  return (
    <div>
      <Row className="justify-content-end mx-0">
        <Col className="d-flex justify-content-end mt-1" md="6" sm="12">
          <Button
            onClick={toggleFormModal}
            color="primary"
            className="btn-sm"
          >
            <PlusSquare size={16} />
            <span className={"ms-1"}>Crear Posicion</span>
          </Button>
        </Col>
      </Row>
      <hr />
      {loading ? (
        <p>Cargando...</p>
      ) : (
        <div className='react-dataTable'>
          <DataTable
            columns={societiesColumns(handleEdit, handleDelete)}
            data={filteredSocieties}
            className='react-dataTable'
            sortIcon={<ChevronDown size={10} />}
            pagination
            highlightOnHover
            pointerOnHover
            responsive
            noHeader
            paginationComponent={() => (
              <CustomPagination
                currentPage={currentPage}
                handlePagination={handlePagination}
                pageCount={Math.ceil(filteredSocieties.length / 20)}
              />
            )}
            paginationDefaultPage={currentPage + 1}
          />
        </div>
      )}
      <DeleteConfirmationModal
        isOpen={isDeleteModalOpen}
        toggle={toggleDeleteModal}
        onConfirm={confirmDelete}
        societyName={selectedSociety?.name || ""}
      />

      <CompanyPositionsFormModal
        isOpen={isFormModalOpen}
        toggle={toggleFormModal}
        onSubmit={handleSubmitSociety}
        initialData={selectedSociety}
      />
    </div>
  );
};

export default CompanyPositionsTable;
